//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibInfo',
  components: {},
  props: {
    classes: String,
    color: String,
    flat: Boolean,
    icon: String,
    hideWhenEmpty: Boolean,
    label: String,
    round: Boolean,
    // rounded: Boolean,
    outline: Boolean,
    square: Boolean
  },
  data: function data() {
    return {
      showModal: false
    };
  }
};